<template>
  <div class="content">
    <div class="table" style="margin-top: 10px">
      <el-table :data="tableData" border>
        <el-table-column prop="ids" label="序号" align="center" width="60px"></el-table-column>
        <el-table-column prop="processDefinitionName" label="流程名称" align="center"></el-table-column>
        <el-table-column prop="title" label="业务标题" align="center"></el-table-column>
        <el-table-column prop="startUserName" label="发起人" align="center"></el-table-column>
        <el-table-column prop="taskName" label="当前任务" align="center"></el-table-column>
        <el-table-column prop="assignee" label="办理人" align="center"></el-table-column>
        <el-table-column prop="startTime" label="开始时间" align="center"></el-table-column>
        <el-table-column prop="durationTime" label="耗时" align="center"></el-table-column>
        <el-table-column prop="status" label="状态" align="center"></el-table-column>
        <el-table-column label="操作" width="150" align="center">
          <template slot-scope="scope">
            <el-button size="mini"  type="primary" plain icon="el-icon-s-unfold"  @click="editRow(scope.row.id)" >历史</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="block" style="margin-top: 30px;">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import { processInstance } from "@/api/api.js"; //流程实例分页查询
export default {
  data() {
    return{
      queryParams:{},
      tableData:[],
      page: 1,
      pageSize: 20,
      total:0
    }
  },
  methods: {
    // 获取列表的数据
    initData(){
      let params ={
        model:{
          ...this.queryParams,
        },
        page: this.page,
        pageSize: this.pageSize
      }
      processInstance(params).then(res=>{
        if (res.data.code == 200) {
          this.tableData = res.data.data.records;
          this.tableData.map((item,index)=>{
            item.ids = index + 1;
            item.startTime = item.startTime.substr(0,16)
          })
          this.total = res.data.data.total;
        }
      })
    },
    // 搜索
    search() {
      this.page = 1,
      this.initData();
    },
    // 重置
    resetForm() {
      for (var i in this.queryParams) {
        this.queryParams[i] = null;
      }
      this.initData();
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.initData();
    },
    handleCurrentChange(page) {
      this.page = page;
      this.initData();
    },
    editRow(id){
      this.$router.push( `/procedure/history/`+id);
    }
  },
  mounted() {
    this.initData()
  },
  created() {
    
  }
};
</script>
<style scoped lang="less">

</style>


